import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment-timezone";

// Components
import SectionBanner from "../../utils/SectionBanner";

// CSS
import "../../../css/list-item.css";

// Util
import { nl2br } from "../../../utils/nl2br";

class TrainingSurveyItem extends Component {
	render() {
		const { translations, item } = this.props;

		return (
			<div className={`list-item`}>
				<SectionBanner
					outsideLink={{
						href: item.url,
						title: (
							<React.Fragment>
								{translations.sections.training_surveys.take_survey_button}{" "}
								<span className="icon-checkmark" />
							</React.Fragment>
						)
					}}
				>
					{item.title}
				</SectionBanner>
				<div className="list-item--content">
					<div className="list-item--description">{nl2br(item.description)}</div>
					<div className="list-item--date">
						<span className="date--label">
							{translations.sections.training_surveys.date_added_label}:
						</span>
						<span>
							{moment
								.utc(item.date_added)
								.local()
								.format("MMM D, Y")}
						</span>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations
	};
};

export default connect(mapStateToProps)(TrainingSurveyItem);



// WEBPACK FOOTER //
// ./src/components/training/surveys/TrainingSurveyItem.js